export default __webpack_public_path__ + "static/media/logo-dark.d9ae9b2d.png";